import React, { useState } from "react";
import { apiRequest } from "../api";
import ReactQuill from "react-quill-new"; // Import ReactQuill
import 'react-quill-new/dist/quill.snow.css';

const AddEmailTemplateTemplateModal = ({ emailTemplateTemplate, onClose, onSave }) => {
    const isEdit = !!emailTemplateTemplate;
    const [name, setName] = useState(emailTemplateTemplate?.name || "");
    const [subject, setSubject] = useState(emailTemplateTemplate?.subject || "");
    const [htmlContent, setHtmlContent] = useState(emailTemplateTemplate?.html_content || "");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token");

    //Editor Options start
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline','strike', 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            ['link', 'image'],
            ['clean']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ];
    //Editor Options end

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            if (isEdit) {
                await apiRequest(
                    `${apiUrl}/email-template-templates/${emailTemplateTemplate.id}`,
                    "PUT",
                    { name, subject, html_content: htmlContent },
                    token
                );
            } else {
                await apiRequest(
                    `${apiUrl}/email-template-templates/`,
                    "POST",
                    { name, subject, html_content: htmlContent },
                    token
                );
            }
            onSave();
        } catch (err) {
            setError("Failed to save email template template.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "600px",
                    maxHeight: "90vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <h4 style={{ marginBottom: "20px", flexShrink: 0 }}>
                    {isEdit ? "Edit Email Template Template" : "Add Email Template Template"}
                </h4>
                <div style={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Subject</label>
                            <input
                                type="text"
                                className="form-control"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>HTML Content:</label>
                            <ReactQuill
                                value={htmlContent}
                                onChange={setHtmlContent}
                                readOnly={loading}
                                theme="snow"
                                modules={modules}
                                formats={formats}
                                placeholder="Enter email template content here..."
                            />
                        </div>
                    </form>
                </div>
                <div className="modal-footer" style={{ flexShrink: 0, marginTop: "20px" }}>
                    <button
                        type="button"
                        className="btn btn-primary"
                        disabled={loading}
                        onClick={handleSubmit}
                    >
                        {loading ? "Saving..." : "Save"}
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                </div>
                {error && (
                    <p
                        style={{
                            marginTop: "10px",
                            color: "red",
                            flexShrink: 0,
                        }}
                    >
                        {error}
                    </p>
                )}
            </div>
        </div>
    );
};

export default AddEmailTemplateTemplateModal; 